import "../styles/Header.css"

function Header() {
  return (
    <header className="header">
      <div className="logo">
        <span className="paw-icon">🐾</span>
        <h1>DogNutrition AI</h1>
      </div>
      <p className="tagline">AI-powered food recommendations for your furry friend</p>
    </header>
  )
}

export default Header

